const API_BASE_URL = 'https://admin.dh.mindflares.net/api';

export async function fetchCategories(signal) {
  const response = await fetch(`${API_BASE_URL}/categories`, { signal });

  if (!response.ok) {
    throw new Error('Failed to load categories');
  }

  const data = await response.json();
  return data;
}
